import { ValidationResult } from "./interface.validation";

export class OdometroHorimetroValidator {
    static odometroHorimetroFormat(item: any): ValidationResult {
        var Odometro_REGEXP: any;
        if (item.value) {
            var tt: any = item.value.replace(/[^0-9]/gi, '');

            Odometro_REGEXP = /([0-9]{6})/;

            if (item.value && !Odometro_REGEXP.test(tt)) {
                return { "incorrectOdometroHorimetroFormat": true };
            }
        }   
       
        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/odometro-horimetro.validation.ts
 **/